import {
  BroadcastController,
  CustomerController,
  NewsController,
} from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import React, { useState } from "react";
import { observer } from "mobx-react";
import { DeleteBroadcast, DeleteNews } from "../../pages";
import { adminStore } from "../../stores";
import { toJS } from "mobx";

const DeleteBroadcastContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const onDelete = async (id) => {
    setLoading(true);
    const { status, errorMessage } = await BroadcastController.deleteBroadcast({
      broadCastId: id,
    });

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    setLoading(false);
    return MimaToastUtil.error({
      message: errorMessage,
    });
  };

  return (
    <DeleteBroadcast
      closeModal={closeModal}
      loading={loading}
      onDelete={onDelete}
      selectedBroadcast={toJS(adminStore.singleBroadcast)}
    />
  );
};

export default observer(DeleteBroadcastContainer);
